class ScrollDown {
  public items: HTMLCollection;

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          let section = item.getAttribute('href');
          if(section)
            document.getElementById(section)?.scrollIntoView({
              behavior: 'smooth'
            });
        });
      });
    }
  }

  cache() {
    this.items = document.getElementsByClassName('a-scroll-down');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ScrollDown;
